import React, { memo, useState, useEffect, Fragment } from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const FormMemo = memo((props) => {
  const { user } = props;
  const [userMemo, setUserMemo] = useState(user.memo);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeMemo = (e) => {
    setUserMemo(e.target.value)
  }

  const onClickMemoUpdate = () => {
    const sure = window.confirm('Are you sure to update memo ?');
    if (sure) {
      var data = {
        mtemployee: {
          memo: userMemo,
        },
        employee_id: user.id,
      };

      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
  
      axios.patch(`/agent/employees/${user.id}/memo`, data)
      .then(resp => {
        console.log("Proxy Memo api ok");
        console.log(resp.data);
        notify("success", "Proxy Memo Update Success!");
      })
      .catch(e => {
        console.log("Proxy Memo api ng");
        console.log(e.response);
        setUserMemo(user.memo);
        alert(JSON.parse(e.request.responseText).errors);
        notify("error", "Proxy Memo Update Error!");
      });
    }
  }

  return (
    <>
      <div className="card mt-3">
        <div className="card-header">
          メモ
        </div>
        <div className="card-body">
          <textarea className="form-control" id="exampleFormControlMemo" rows="5" placeholder="メモ" onChange={onChangeMemo} value={userMemo || ''}></textarea>
        </div>
        <div className="card-footer text-center">
          <button 
            className="btn btn-secondary text-white w-100" 
            onClick={onClickMemoUpdate}
          >
            メモ更新
          </button>
        </div>
      </div>
    </>
  );
});